var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1283_14375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1283_14375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.375,
    width: 24.75,
    height: 18,
    rx: 2,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.742104 0H-3.375V3L18.7278 18L21.375 18V15L-0.742104 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.49685 0L21.375 16.2425V18H20.5174L-3.375 1.74067V0H-2.49685Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0179 0H21.375V3C21.375 3 6.06513 12.9937 -1.01786 18H-3.375V15L19.0179 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 0H20.5756L-3.375 16.2565V18H-2.49685L21.375 1.75382V0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62584 0H12.3947V5.55218H21.375V12.4442H12.3947V18H5.62584V12.4442H-3.375V5.55218H5.62584V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04605 0H10.9539V6.92308H21.375V11.0769H10.9539V18H7.04605V11.0769H-3.375V6.92308H7.04605V0Z",
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1283_14375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1283_14375"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.375,
    width: 24.75,
    height: 18,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEng);
export default __webpack_public_path__ + "static/media/langENG.aa28dfeec151a46c8ea1d9d5205c198c.svg";
export { ForwardRef as ReactComponent };